export function footerAccordion() {
  // Only initialize on mobile devices
  const isMobile = window.innerWidth <= 1200; // Match the up-to-landscape breakpoint

  if (!isMobile) {
    return; // Exit early on desktop
  }

  const footerAccordions = document.querySelectorAll('.footer-menu-acordeon');

  footerAccordions.forEach((accordion) => {
    const heading = accordion.querySelector('.is-heading');
    const headingLink = heading?.querySelector('a');

    if (heading && headingLink) {
      // Handle click on the entire heading area
      heading.addEventListener('click', (e) => {
        const isExpanded = accordion.classList.contains('is-expanded');

        if (isExpanded) {
          // If already expanded, allow navigation
          return; // Let the link handle navigation naturally
        } else {
          // If not expanded, expand the accordion
          e.preventDefault();
          e.stopPropagation();

          // Expand current accordion
          accordion.classList.add('is-expanded');

          // Close other accordions when one is opened
          footerAccordions.forEach((otherAccordion) => {
            if (otherAccordion !== accordion) {
              otherAccordion.classList.remove('is-expanded');
            }
          });
        }
      });

      // Handle click specifically on the link
      headingLink.addEventListener('click', (e) => {
        const isExpanded = accordion.classList.contains('is-expanded');

        if (isExpanded) {
          // If expanded, allow normal navigation
          return; // Let the link work normally
        } else {
          // If not expanded, prevent navigation and expand accordion
          e.preventDefault();
          e.stopPropagation();

          // Expand current accordion
          accordion.classList.add('is-expanded');

          // Close other accordions when one is opened
          footerAccordions.forEach((otherAccordion) => {
            if (otherAccordion !== accordion) {
              otherAccordion.classList.remove('is-expanded');
            }
          });
        }
      });
    }
  });

  // Handle window resize to enable/disable functionality
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const newIsMobile = window.innerWidth <= 1200;

      if (newIsMobile !== isMobile) {
        // Reload the page or reinitialize if breakpoint changes
        // This ensures proper behavior when switching between mobile/desktop
        location.reload();
      }
    }, 250);
  });
}
